import React, { useState, useEffect } from 'react';
import { Image as ImageIcon } from 'lucide-react';

interface Props {
  imageUrls: string[];
  className?: string;
  errorIconSize?: number;
}

export const SmartNetworkImage: React.FC<Props> = ({ imageUrls, className, errorIconSize = 16 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [hasError, setHasError] = useState(false);

  // If the list of URLs changes, reset state
  useEffect(() => {
    setCurrentIndex(0);
    setHasError(false);
  }, [imageUrls]);

  if (!imageUrls || imageUrls.length === 0 || hasError || currentIndex >= imageUrls.length) {
    return (
      <div className={`flex items-center justify-center bg-gray-100 ${className || ''}`}>
        <ImageIcon size={errorIconSize} className="opacity-20 text-gray-500" />
      </div>
    );
  }

  const handleError = () => {
    if (currentIndex + 1 < imageUrls.length) {
      setCurrentIndex(prev => prev + 1);
    } else {
      setHasError(true);
    }
  };

  return (
    <img
      src={imageUrls[currentIndex]}
      className={className}
      onError={handleError}
      alt="Product"
    />
  );
};
